export default __webpack_public_path__ + "static/media/smardroponics_tablet_signin.85b2933a.png";